import React from 'react';

const Reporteador = () => {
    return (
        <h1>Reporteador</h1>
    );
}
 
export default Reporteador;